
import { Component, Vue } from 'vue-property-decorator'
import GoodsBaseInfo from '@/views/goodsManage/commodity/template/GoodsBaseInfo.vue'
import GoodsImageInfo from '@/views/goodsManage/commodity/template/GoodsImageInfo.vue'
import GoodsSpec from '@/views/goodsManage/commodity/template/GoodsSpec.vue'
import GoodsPackage from '@/views/goodsManage/commodity/template/GoodsPackage.vue'
import { Getter } from 'vuex-class'
import { addGoodsSubmit, editGoodsSubmit, getGoodsBrandList, getGoodsInfo, GoodsBrandListDto, GoodsSubmitDto, GoodsTagListDto } from '@/api/commodity'
import { brandDto, goodsDetailDto } from '@/api/goods'

@Component({
  components: {
    GoodsBaseInfo,
    GoodsImageInfo,
    GoodsSpec,
    GoodsPackage
  }
})
export default class addCommodity extends Vue {
  @Getter companyId!: string
  $refs!: {
    goodsBaseInfo: GoodsBaseInfo;
    goodsImageInfo: GoodsImageInfo;
    goodsSpec: GoodsSpec;
    goodsPackage: GoodsPackage
  }
  labelWidth = 100
  imageUrl = []
  mainImageUrl = []
  value = ''
  categoryName = '水果'
  showPicker = false
  showLevelPicker = false
  goodsTagList: GoodsTagListDto[] = []
  brandList: GoodsBrandListDto[] = []
  formData: GoodsSubmitDto = {
    upRighNow: true,
    companyId: '',
    goodsName: '',
    goodsCategoryId: '',
    goodsBrandId: '',
    keyword: '',
    goodsCode: '',
    categoryName: '',
    brandName: '',
    /* 是否开启商品多规格(0:不开启,1:开启) */
    multiSpec: '',
    goodsVideoName: '',
    goodsVideoUrl: '',
    goodsVideoSize: '',
    /*  商品描述文件url*/
    descriptionUrl: '',
    /* 商品描述内容 */
    descriptionContext: '',
    /* 商品描述文件size */
    descriptionSize: '',
    /* 商品标签编号 */
    goodsTagId: '',
    /* 规格编号 */
    specificationId: '',
    /* 规格名称 */
    attrName: '',
    /* 规格值 */
    attrValue: '',
    /* 规格值编码 */
    attrValueCode: '',
    /* 规格序号 */
    attrSortNum: '',
    /* 套餐编号 */
    goodsPackageId: '',
    /* 序号 */
    serialNumber: '',
    /* 套餐名称 */
    packageName: '',
    /* 套餐编码 */
    packageCode: '',
    /* 套餐条形码 */
    barcode: '',
    /* 重量 */
    weight: '',
    /* 套餐主图 */
    mainImageUrl: '',
    /*套餐主图大小  */
    mainImageSize: '',
    /*套餐状态  */
    packageStatus: '',
    /* 市场价 */
    marketPrice: '',
    /* 参考成本价 */
    referPrice: '',
    /* 是否启用客户级别定价 */
    isUseCusLevelPrice: '',
    /* 是否启用客户定价 */
    isUseCusPrice: '',
    /* 价格设置是否同步至其他套餐 */
    isSyncOther: '',
    /* 客户级别定价表ID */
    autoId: '',
    /* 客户级别编号 */
    customerLevelId: '',
    orderPrice: '',
    /* 起订量 */
    minimum: '',
    /* 限定量 */
    maximum: '',
    /*客户编号  */
    customerId: '',
    /* 商品图册图片路径 */
    imageUrl: '',
    /* 图片大小 */
    imageSize: '',
    /* 商品编号 */
    goodsId: '',
    /* 规格是否变动（包含删除和新增） */
    isSpecification: '',
    goodsTagList: [],
    brandList: []
  }
  goodsId = ''
  goodsData: goodsDetailDto = {}
  form = {
    upRighNow: true // 是否立即上架
  }
// 用于控制物理按键返回问题  1:当前视图页面在添加编辑主页面  2:当前视图页面在商品分类弹框页面
// 3:当前视图页面在商品品牌弹框页面 4:当前视图页面在商品标签弹框页面  5:当前视图页面在商品套餐弹框页面
// 6:当前视图页面在商品套餐弹框页面的按客户级别设置页面中 7:当前视图页面在商品套餐弹框页面的按客户设置页面中
  currentPage = 1

  created () {
    this.formData.companyId = this.companyId
    this.goodsId = this.$route.query.goodsId as string
    if (this.$isEdit || this.$isCopy) {
      this.getGoodsInfo()
    }
    this.getbrandList()
    this.$eventBus.$on('currentPage', (data) => {
      this.changeCurrentPage(data)
    })
    // console.log('this.$route.query.upRighNow',this.$route.query.upRighNow);
    // 判断是否是下架状态
    if (this.$route.query.upRighNow === '下架') {
      this.form.upRighNow = false
    }
  }

  mounted () {
    // 注册原生调用h5返回事件currentPage
    this.handleAppBack()
  }

  /**
   * 监听原生APP的返回事件
   */
  handleAppBack () {
    this.$bridge.registerHandler(
      'companyMsgBack', () => {
        console.log('原生已调用')
        switch (this.currentPage) {
          case 1:
            this.handleBack()
            break
          case 2:
            this.$refs.goodsBaseInfo.handleCategoryAppCancel()
            break
          case 3:
            this.$refs.goodsBaseInfo.handleBrandAppCancel()
            break
          case 4:
            this.$refs.goodsBaseInfo.handlTigAppCancel()
            break
          case 5:
            this.$refs.goodsPackage.handlPackageAppCancel()
            break
          case 6:
            this.$refs.goodsPackage.handlPriceAppCancel()
            break
          case 7:
            this.$refs.goodsPackage.handlPricesAppCancel()
            break
        }
      }
    )
  }

  handleBack () {
    if (this.currentPage === 1) {
      this.$confirmDialog.show({
        okText: '确认',
        cancelText: '取消',
        tips: '现在退出则不会保存已修改内容，是否确认退出?',
        onOk: () => {
          this.$router.back()
        },
      })
    }
  }

  handleHomeBack () {
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '现在退出则不会保存已修改内容，是否确认退出?',
      onOk: () => {
        this.$goHomeBack()
      },
    })
  }

  changeCurrentPage (num) {
    this.currentPage = num
  }

  get $isCopy () {
    return 'copy' === this.$route.query.op as string
  }

  get navTitle () {
    return 'edit' === this.$route.query.op ? '修改商品' : '发布商品'
  }

  changeUp () {
    this.form.upRighNow = this.form.upRighNow ? false : true
  }

  setData () {
    this.$refs.goodsBaseInfo.setData(this.goodsData)
    this.$refs.goodsImageInfo.setData(this.goodsData.goodsImageList, this.goodsData.videoUrl)
    this.$nextTick(() => {
      this.$refs.goodsSpec.setData(this.goodsData)
      this.$refs.goodsPackage.setData(this.goodsData)
    })
  }

  /**
   * 获取商品详情
   */
  getGoodsInfo () {
    getGoodsInfo({goodsId: this.goodsId}).then(res => {
      this.goodsData = JSON.parse(JSON.stringify(res.data || {}))
      this.$nextTick(() => {
        this.setData()
      })
    })
  }

  /**
   * 获取商品品牌列表
   */
  getbrandList () {
    const params = {
      pageIndex: 1,
      pageSize: 10,
      isPage: true
    }
    getGoodsBrandList(params).then((res: any) => {
      this.brandList = res.data.brandList || []
    })
  }

  onConfirm (value: any) {
    this.formData.companyId = value.id

    this.showPicker = false
  }

  brandConfirm (value: brandDto) {
    this.formData.brandName = value.brandName
    this.formData.goodsBrandId = value.brandId
    this.showLevelPicker = false
  }

  submitData (upRighNow: boolean, config: any = {}) {
    return new Promise(resolve => {
      Promise.all([
        this.$refs.goodsBaseInfo.handleSubmit(),
        this.$refs.goodsImageInfo.handleSubmit(),
        this.$refs.goodsSpec.handleSubmit(),
        this.$refs.goodsPackage.handleSubmit(),
      ]).then(([baseInfo, imageInfo, specInfo, packageInfo]: any[]) => {
        const base: any = baseInfo
        const goodsTagIdList = (base as any).goodsTagIdList.map((item: string) => {
          return {goodsTagId: item}
        })
        base.goodsTagIdList = goodsTagIdList
        const params = {
          ...this.goodsData,
          ...base,
          ...specInfo,
          ...packageInfo,
          ...imageInfo.video,
          goodsImageList: imageInfo.imgList,
          upRighNow: this.form.upRighNow
        }
        // 如果是预览操作，就不往下执行
        if (config.type === 'preview') {
          resolve(JSON.parse(JSON.stringify(params)))
          return false
        }
        (this.$isEdit ? editGoodsSubmit : addGoodsSubmit)(params).then(res => {
          this.$toast.success({
            message: '保存成功',
            duration: 1000,
            onClose: () => {
              setTimeout(()=>{
                if (!this.$isEdit) {
                  window.sessionStorage.setItem("isRefresh", "1");
                  this.$router.replace('/addSuccess')
                } else {
                  window.sessionStorage.setItem("isRefresh", "1");
                  this.$router.replace({
                    path: '/commodity',
                    query: {
                      goodsId: this.goodsId,
                      upRighNow: this.form.upRighNow ? '上架' : '下架'
                    }
                  })
                }
              },200)
            }
          });
        })
      })
    })
  }

  stopAdd () {
    // (this.$refs.creatCompany as any).validate().then(() => {
    //   console.log(this.formData)
    //   addGoodsSubmit(this.formData).then(()=>{
    //     this.formData.upRighNow=false
    //     this.$toast.success("商品信息保存成功");
    //     this.$router.back();

    //   })

    // });
  }
}
